import React from "react";
import { Form, Table, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";

const CatalogSubRegions = ({ subRegions, onChange, onAdd, onRemove, viewOnly, loading }) => (
  <div className="mb-3">
    <div className="d-flex justify-content-between align-items-center mb-1">
      <h6 className="mb-0">Sub-Regions</h6>
      {!viewOnly && (
        <Button variant="outline-primary" size="sm" onClick={onAdd} disabled={loading}>
          <FontAwesomeIcon icon={faPlus} className="me-1" />
          Add
        </Button>
      )}
    </div>

    {!loading && subRegions.length === 0 && <p className="text-muted mb-0">No sub-regions.</p>}

    {subRegions.length > 0 && (
      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
        <Table striped bordered hover size="sm" className="mb-0">
          <thead style={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Description</th>
              <th scope="col" style={{ width: "60px" }}></th>
            </tr>
          </thead>
          <tbody>
            {subRegions.map((item) => (
              <tr key={item.clientKey}>
                <td>
                  <Form.Control
                    type="text"
                    size="sm"
                    placeholder="Enter sub-region name"
                    value={item.name}
                    onChange={(e) => onChange(item.clientKey, "name", e.target.value)}
                    disabled={viewOnly}
                  />
                </td>
                <td>
                  <Form.Control
                    type="text"
                    size="sm"
                    placeholder="Enter sub-region description"
                    value={item.description || ""}
                    onChange={(e) => onChange(item.clientKey, "description", e.target.value)}
                    disabled={viewOnly}
                  />
                </td>
                <td className="text-center">
                  {!viewOnly && (
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => onRemove(item.clientKey)}
                      aria-label={`Remove sub-region ${item.name}`}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    )}
  </div>
);

export default CatalogSubRegions;
